export const Logo = ({ dark = false, className = "" }) => (
  <span className={`group/logo inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <span className="flex h-9 w-9 md:h-10 md:w-10 shrink-0 items-center justify-center rounded-xl bg-white border border-slate-200 shadow-[0_4px_14px_-4px_rgba(11,21,40,0.25)] overflow-hidden transition-transform duration-500 group-hover/logo:rotate-[-6deg] group-hover/logo:scale-105">
      <img src="/assets/logo-mark.png" alt="" className="h-7 w-7 md:h-8 md:w-8 object-contain" />
    </span>
    <span className={`font-extrabold tracking-[0.06em] text-lg md:text-xl leading-none ${dark ? "text-white" : "text-[#0B1528]"}`}>
      DESANTRIX<span className="text-amber-500">.</span>
    </span>
  </span>
);
